import { Controller } from "@hotwired/stimulus"
import React, { Suspense } from "react"
import { render } from "react-dom"
import { BrowserRouter as Router } from "react-router-dom"
import {
  ErrorBoundary,
  Loading,
  ModalContainer,
  ViewOrEditTLO,
} from "web/components"
import { TLOContextProvider } from "web/contexts"
import { useCompany } from "web/hooks/data"
import { AppProviders, LibraryProviders } from "web/Providers"

export default class ViewOrEditTLOController extends Controller {
  static values = {
    subjectType: String,
    subjectId: Number,
  }

  initialize() {
    global.React = React
  }

  connect() {
    const CompanyTLOContextProvider = ({ children }) => {
      return (
        <TLOContextProvider
          subjectType={this.subjectTypeValue}
          data={useCompany(this.subjectIdValue)}
        >
          {children}
        </TLOContextProvider>
      )
    }

    render(
      <Suspense fallback={<Loading />}>
        <Router>
          <LibraryProviders>
            <AppProviders>
              <CompanyTLOContextProvider>
                <ErrorBoundary>
                  <ViewOrEditTLO />
                </ErrorBoundary>
              </CompanyTLOContextProvider>
              <ModalContainer />
            </AppProviders>
          </LibraryProviders>
        </Router>
      </Suspense>,
      this.element
    )
  }
}
